import * as React from "react";
import { useState, useEffect } from "react";
import { Alert } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../Features/authSlice";
import { useNavigate } from 'react-router-dom'
import { Form, Row, Col, Button, Card } from "react-bootstrap";


const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, error, message } = useSelector(
    (state) => state.auth
  )
  useEffect(() => {
    if (error) {
      setErrors(message);
    }
    else if (user) {
      navigate('/')
    }
  }, [user, error, message, navigate])
  const handleSubmit = async (e) => {
    e.preventDefault();
    const userData = {
      seller_profile_email: email,
      seller_profile_password: password,
    }
    dispatch(login(userData))
  }

  return (
    <div style={{height: '75vh'}} className={`d-flex justify-content-center align-items-center`}>
      <Card style={{ width: '450px' }} className="border-0 py-5">
        <Form onSubmit={handleSubmit}>
          <h1 className="text-center pb-3">Login</h1>
          <h5 className="text-center pb-3">Welcome Back!</h5>
          {errors && <Alert severity="error">{errors}</Alert>}
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control type="email" placeholder="Enter email" value={email} onChange={(e) => setEmail(e.target.value)} />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Password</Form.Label>
                <Form.Control type="password" placeholder="Enter Password" value={password} onChange={(e) => setPassword(e.target.value)} />
              </Form.Group>
            </Col>
          </Row>

          <div className="my-4">
            <Button variant="primary" type="submit" className="w-100">
              Login
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
